const drawingToolsTypes = {
  SET_TOOL: 'SET_TOOL',
  SET_COLOR: 'SET_COLOR',
  DRAWINGTOOLS_OPEN: 'DRAWINGTOOLS_OPEN',
  DRAWINGTOOLS_CLOSE: 'DRAWINGTOOLS_CLOSE',
  INSERTURL_OPEN: 'INSERTURL_OPEN',
  INSERTURL_CLOSE: 'INSERTURL_CLOSE',
  SET_MULTIMEDIA_TAB: 'SET_MULTIMEDIA_TAB'
}

export default drawingToolsTypes
